export default __webpack_public_path__ + "static/tile_tablet-23685014938b81ca89ca60281d90c316.png";